import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-portal-footer',
  templateUrl: './portal-footer.component.html',
  styleUrls: ['./portal-footer.component.scss']
})
export class PortalFooterComponent implements OnInit {

  constructor(    private router: Router) { }
  ano: number = (new Date()).getFullYear();

  ngOnInit(): void {
    
  }
  navigateToSection(sectionId: any): void {
    const sectionName = document.getElementById(sectionId);
    if (sectionId === "home") {
      if (sectionName) {
        this.router.navigate([], { fragment: "/"});
        sectionName.scrollIntoView();
      }
    }
  
    else {
   let selector = document.querySelector('#' + sectionId);
      if (selector !== null) {
        this.router.navigate([], { fragment:"/"+ sectionId });
         selector.scrollIntoView({ block: 'start' });
       }
  } 
  }
}
